import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, {} from 'react';
import { Form, Modal } from 'antd';
import OffsetDateTimePicker from "./OffsetDateTimePicker";
const DateTimeModal = ({ open, title = "Date and Time", description, onCancel, onComplete }) => {
    const [form] = Form.useForm();
    const onOk = () => {
        form.submit();
    };
    const onFinish = (formValues) => {
        onComplete(formValues.dateTime);
    };
    return (_jsxs(Modal, { title: title, open: open, onOk: onOk, onCancel: onCancel, afterClose: () => form.resetFields(), children: [description && _jsx("p", { children: description }), _jsx(Form, { form: form, onFinish: onFinish, children: _jsx(Form.Item, { label: 'Date Time', name: "dateTime", rules: [
                        { required: true, message: 'Date and time is required' }
                    ], children: _jsx(OffsetDateTimePicker, { showTime: true, format: "DD/MM/YYYY HH:mm" }) }) })] }));
};
export default DateTimeModal;
